import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onConfirm", "reviewType", "title"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useCallback, useMemo, useState } from 'react';
import { APP } from '../../constants/ReviewType';
import BaseReviewModal from './BaseReviewModal';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReviewReplyModal(_ref) {
  let {
      onConfirm,
      reviewType = APP,
      title = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.modal.reply.title"
      })
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [reply, setReply] = useState('');
  const form = useMemo(() => {
    return /*#__PURE__*/_jsx(Form, {
      children: /*#__PURE__*/_jsx(FormControl, {
        "data-test-id": "review-reply-modal",
        required: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.modal.reply.reply"
        }),
        children: /*#__PURE__*/_jsx(TextArea, {
          "data-test-id": "review-reply-modal-input",
          placeholder: unescapedText(`marketplace-ui-reviews.modal.reply.replyPlaceholder.${reviewType}`),
          value: reply,
          onChange: ({
            target: {
              value
            }
          }) => setReply(value),
          rows: 6
        })
      })
    });
  }, [reply, reviewType]);
  const handleConfirm = useCallback(() => {
    const confirmPromise = onConfirm({
      reply
    });
    if (confirmPromise instanceof Promise) {
      confirmPromise.then(() => {
        FloatingAlertStore.addAlert({
          message: unescapedText(`marketplace-ui-reviews.reply.notifications.success.message.${reviewType}`),
          titleText: unescapedText('marketplace-ui-reviews.reply.notifications.success.titleText'),
          type: 'success'
        });
      }).catch(__err => {
        FloatingAlertStore.addAlert({
          message: unescapedText('marketplace-ui-reviews.reply.notifications.fail.message'),
          titleText: unescapedText('marketplace-ui-reviews.reply.notifications.fail.titleText'),
          type: 'danger'
        });
      });
    }
  }, [onConfirm, reply, reviewType]);
  return /*#__PURE__*/_jsx(BaseReviewModal, Object.assign({}, rest, {
    title: title,
    form: form,
    confirmDisabled: !reply,
    confirmButtonDataId: "review-reply-submit-button",
    onConfirm: handleConfirm,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.modal.reply.tooltip"
    })
  }));
}